import { render, staticRenderFns } from "./CreateLog.vue?vue&type=template&id=4a0330e6&lang=pug"
import script from "./CreateLog.vue?vue&type=script&lang=js"
export * from "./CreateLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports